import { Vacancy } from "../VacancyModel";
import { useEffect, useState } from "react";
import Content from "../../Content";
import SearchJobs from "../../SearchJobs";
import { Pagination } from "antd";
import VacancyCard from "./VacancyCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileCircleXmark } from "@fortawesome/free-solid-svg-icons";
import useFilterJob from "@/hooks/useFilterJob";

export default function VacancyList({ data, convertDate, handleCopyLink, handleApplyButtonClick }) {
  const PAGE_SIZE = 12;
  const { job, businessUnit, experienceLevel } = useFilterJob(state => state);

  const [currentPage, setCurrentPage] = useState(1);
  const [filteredDataLength, setFilteredData] = useState<number>(0);
  const [paginatedData, setPaginatedData] = useState<Vacancy[]>([]);

  useEffect(() => {
    const jobTitle = String(job || "");
    const unit = String(businessUnit || "");
    const category = String(experienceLevel || "");

    const regexJob = new RegExp(jobTitle, "i");
    const regexUnit = new RegExp(unit, "i");
    const regexCategory = new RegExp(category, "i");

    const filteredData =
      data?.vacancies.filter((vacancy) => {
        return (
          (jobTitle === "" || regexJob.test(vacancy.title)) &&
          (unit === "" || regexUnit.test(vacancy.businessUnitName)) &&
          (category === "" || regexCategory.test(vacancy.categoryName))
        );
      }) ?? [];

    setFilteredData(filteredData.length);

    const startIndex = (currentPage - 1) * PAGE_SIZE;
    const paginatedData = filteredData.slice(startIndex, startIndex + PAGE_SIZE);

    setPaginatedData(paginatedData);
  }, [currentPage, businessUnit, experienceLevel, job, data?.vacancies]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [filteredDataLength])

  return (
    <Content>
      <div className="pt-2 xs:mt-3 px-4">
        <SearchJobs />
      </div>

      <div className="px-0 xs:px-[1rem] sm:px-6 md:px-10">
        <h2 className="text-lg sm:text-xl py-6 sm:py-10 font-semibold">
          ({filteredDataLength}) Available Jobs
        </h2>

        {paginatedData && paginatedData.length > 0 ? (
          <div className="grid grid-cols-2 lg:grid-cols-4 xs:gap-5 md:gap-4">
            {paginatedData.map((item, index) => (
              <VacancyCard
                key={index}
                item={item}
                handleCopyLink={handleCopyLink}
                convertDate={convertDate}
                handleApplyButtonClick={handleApplyButtonClick} />
            ))}
          </div>
        )
          : (
            <div className="flex justify-center py-20">
              <div className="flex flex-col content-center">
                <FontAwesomeIcon icon={faFileCircleXmark} color="silver" className="fa-5x mb-5" />
                <p className="text-2xl font-medium text-center">Search not found</p>
                <p className="text-center">
                  We&#39;re sorry we can&#39;t find the job you&#39;re looking for.<br />Please search another job
                </p>
              </div>
            </div>
          )
        }

        <div className="my-6 container">
          <div className="flex justify-center w-full">
            <Pagination
              defaultCurrent={1}
              current={currentPage}
              pageSize={PAGE_SIZE}
              total={filteredDataLength}
              showSizeChanger={false}
              onChange={handlePageChange}
              className="flex"
            />
          </div>
        </div>
      </div>
    </Content>
  );
}